module.exports = __webpack_public_path__ + "img/salvaged.cleaver.29fb3451.png";